/**
 * Account Page Component
 * 
 * User account information and settings page
 * Displays logged-in user details using AuthData context
 * 
 * Features:
 * - Shows current user information
 * - Requires authentication to access
 * - Uses AuthData context for user state
 * 
 * Dependencies:
 * - AuthWrapper: User authentication context
 * 
 * @component
 * @returns {JSX.Element} Account page with user information
 * 
 * @example
 * // Usage in router (protected route)
 * <Route path="/account" element={<Account />} isPrivate={true} />
 */

import React from "react";
import { AuthData } from "../../auth/AuthWrapper"

/**
 * Account Component
 * Displays user account information
 * 
 * Hooks:
 * - AuthData: Gets user object with name and other details
 * 
 * @function
 * @returns {JSX.Element} Account page with username display
 */
export const Account = () => {
     // Get user data from authentication context
     const { user } = AuthData();

     return (
          <div className="page">
               {/* Page heading */}
               <h2>Your Account</h2>
               {/* Display logged-in username from context */}
               <p>Username: {user.name}</p>
          </div>
     )
}